/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WhatIfData } from "../models/http/what-if/what-if-data.model";
import { WhatIfHttpService } from "./http/what-if-http.service";

@Injectable({
	providedIn: "root"
})
export class WhatIfService {
	constructor(private _whatIfHttpService: WhatIfHttpService) {}

	/**
	 * Retrieves the "What If" data for a specific user.
	 *
	 * @param appId - The application ID.
	 * @param tenantId - The tenant ID.
	 * @param time - (Optional) The specific time for which to retrieve the data.
	 * @returns An Observable that emits the WhatIfData.
	 */
	public getUserWhatIfData(
		appId: string,
		tenantId: string,
		time?: string
	): Observable<WhatIfData> {
		return this._whatIfHttpService.getUserWhatIfData(appId, tenantId, time);
	}
}
